export const SUCCESS = 200;
export const SUCCESS_201 = 201;
export const SUCCESS_206 = 206;
